import { ComponentPropsWithoutRef } from "react";
import { twMerge } from "tailwind-merge";
import { StatusAgendamentoEnum } from "../../../enums/statusAgendamento";
import { formatStatusLabel } from "./formatStatusLabel";

const STATUS_COLOR_CLASSES: Record<StatusAgendamentoEnum, string> = {
  [StatusAgendamentoEnum.ABERTO]: "bg-[#31cbec]/10 border-[#31cbec] text-[#31cbec]",
  [StatusAgendamentoEnum.AGUARDANDO_PAGAMENTO]:
    "bg-[#d0c808]/10 border-[#d0c808] text-[#d0c808]",
  [StatusAgendamentoEnum.AGENDADO]: "bg-[#558fff]/10 border-[#558fff] text-[#558fff]",
  [StatusAgendamentoEnum.FINALIZADO]: "bg-[#1bbb48]/10 border-[#1bbb48] text-[#1bbb48]",
  [StatusAgendamentoEnum.INICIADO]: "bg-[#0025a8]/10 border-[#0025a8] text-[#0025a8]",
  [StatusAgendamentoEnum.CANCELADO]: "bg-[#e42e30]/10 border-[#e42e30] text-[#e42e30]",
  [StatusAgendamentoEnum.PAGO]: "bg-[#1bbb48]/10 border-[#1bbb48] text-[#1bbb48]",
  [StatusAgendamentoEnum.REEMBOLSADO]: "bg-[#ee6f27]/10 border-[#ee6f27] text-[#ee6f27]",
};

interface IStatusTagV2Props extends ComponentPropsWithoutRef<"span"> {
  status: string;
}

export const StatusTagV2 = ({ status, className, ...rest }: IStatusTagV2Props) => {
  const colorClasses = STATUS_COLOR_CLASSES[status as StatusAgendamentoEnum];

  return (
    <span
      {...rest}
      className={twMerge(
        "inline-flex items-center justify-center rounded-full border border-solid px-2.5 py-1 font-['Mulish'] text-sm font-normal whitespace-nowrap",
        colorClasses,
        className,
      )}
    >
      {formatStatusLabel(status)}
    </span>
  );
};
